import React from 'react';
import { Input, Modal, Button } from 'antd';
import messager from "../ui/messager";
import http from "../../axios/http";
import PasswordEncryptor from "../../util/PasswordEncryptor";

const PWD_KEY = 'OTPBIND'

class VerifyCode extends React.Component {
    constructor(props) {
        super(props);

        const length = props.length || 6;
        this.state = {
            values: Array(length).fill(''),
            seconds: props.countdown || 60,
            counting: true,
            // imageSrc: 'data:image/png;base64,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'
            imageSrc: ''
        };

        this.inputsRef = [];
        this.timer = null;
    }

    componentDidMount() {
        // this.startCountdown();
        // 自动聚焦第一个
        setTimeout(() => {
            const first = this.inputsRef[0];
            if (first && first.focus) first.focus();
        }, 0);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.visible && this.props.visible) {
            if (this.props.type !== 'otp') {
                this.startCountdown()
            }
            this.reset()
        }

    }
    // 绑定OTP
    bindOtp = () => {

        const pwd = PasswordEncryptor.encryptPassword(
            this.props.param.password,
            this.props.param.username,
            PWD_KEY
        );
        let param = {
            username: this.props.param.username,
            password: pwd
        }
        this.reset()
        http.post({
            url: '/userOTP/bindOtp',
            data: param,
            success: (res) => {
                this.setState({
                    imageSrc: res
                })
            },
            error: (res) => {
                messager.alert(res, "绑定OTP失败", "error");
            }
        });
    }

    reset = () => {
        this.clearTimer();
        this.setState({
            values: Array(this.state.values.length).fill(''),
            seconds: this.props.countdown || 60,
            counting: true,
            imageSrc: ''
        });
    };

    componentWillUnmount() {
        this.clearTimer();
    }

    /* ================= 倒计时 ================= */

    startCountdown = () => {
        this.clearTimer();
        http.post({
            url: '/message/sendMessageForLogin',
            data: {
                userName: this.props.param.username
            },
            success: (res) => {
                if(res.code!==200){
                    this.clearTimer();
                    this.setState({
                        seconds: 0,
                        counting: false
                    })
                    messager.alert(res.message);

                }else{
                    this.setState({ counting: true });
                    this.timer = setInterval(() => {
                        this.setState(prev => {
                            if (prev.seconds <= 1) {
                                this.clearTimer();
                                return { seconds: 0, counting: false };
                            }
                            return { seconds: prev.seconds - 1 };
                        });
                    }, 1000);
                }

            },
            error: (res) => {
                this.clearTimer();
                this.setState({
                    seconds: 0,
                    counting: false
                })
                messager.alert(res, "发送失败", "error");
            }
        });
    };

    clearTimer = () => {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    };

    resendCode = () => {
        const { onResend, countdown = 60 } = this.props;

        this.setState(
            {
                values: Array(this.state.values.length).fill(''),
                seconds: countdown,
                counting: true
            },
            () => {
                this.startCountdown();
                onResend && onResend();
                const first = this.inputsRef[0];
                if (first && first.focus) first.focus();
            }
        );
    };

    /* ================= 输入处理 ================= */

    handleChange = (e, index) => {
        const val = e.target.value.replace(/\D/g, '');
        if (!val) return;

        const values = [...this.state.values];
        values[index] = val[0];

        this.setState({ values }, () => {
            if (index < values.length - 1) {
                const next = this.inputsRef[index + 1];
                if (next && next.focus) next.focus();
            }

            if (values.every(v => v)) {
                // const code = values.join('');
                // this.props.onComplete && this.props.onComplete(code);
            }
        });
    };

    handleKeyDown = (e, index) => {
        const values = [...this.state.values];

        if (e.key === 'Backspace') {
            e.preventDefault();

            if (values[index]) {
                values[index] = '';
                this.setState({ values });
            } else if (index > 0) {
                values[index - 1] = '';
                this.setState({ values }, () => {
                    const prev = this.inputsRef[index - 1];
                    if (prev && prev.focus) prev.focus();
                });
            }
        }
    };

    /* ================= 弹窗 ================= */

    handleOk = () => {
        const code = this.state.values.join('');
        this.props.onComplete && this.props.onComplete(code);
    };

    handleCancel = () => {
        // this.setState({ visible: false });
        this.clearTimer();
        this.props.onCancel && this.props.onCancel();
    };

    handlePaste = (e) => {
        const text = e.clipboardData.getData('text').replace(/\D/g, '');
        if (!text) return;

        const values = [...this.state.values];
        text.slice(0, values.length).split('').forEach((v, i) => {
            values[i] = v;
        });

        this.setState({ values });
    };

    /* ================= 渲染 ================= */

    renderInputs() {
        return (
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                {this.state.values.map((v, i) => (
                    <Input
                        key={i}
                        ref={el => (this.inputsRef[i] = el)}
                        maxLength={1}
                        value={v}
                        inputMode="numeric"
                        onChange={e => this.handleChange(e, i)}
                        onKeyDown={e => this.handleKeyDown(e, i)}
                        onPaste={this.handlePaste}
                        style={{
                            width: 46,
                            height: 46,
                            textAlign: 'center',
                            fontSize: 20
                        }}
                    />
                ))}
            </div>
        );
    }

    renderFooter() {
        const { counting, seconds } = this.state;
        const { type } = this.props;

        return (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {type === 'sms'?
                    <span style={{ color: '#999' }}>{counting ? `${seconds}s 后可重新发送` : ''}</span>
                    :''}
                {type === 'sms'?
                    <Button
                        type="link"
                        disabled={counting}
                        onClick={this.resendCode}
                    >
                        重新发送
                    </Button>
                    :
                    <Button
                        type="primary"
                        onClick={this.bindOtp}
                    >
                        获取otp认证
                    </Button>
                }

            </div>
        );
    }

    render() {
        return (
            <Modal
                style={{paddingTop: '10%'}}
                title={this.props.type === 'otp'? '请输入OTP验证码':'请输入短信验证码'}
                visible={this.props.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                okText={'确定'}
                cancelText={'取消'}
                destroyOnClose
            >
                {this.renderInputs()}
                <div style={{ marginTop: 16 }}>
                    {this.renderFooter()}
                </div>

                {this.state.imageSrc && (
                    <div style={{ textAlign: 'center', marginTop: 12 }}>
                        <img
                            alt=""
                            width={200}
                            src={this.state.imageSrc}
                        />
                        <div style={{ marginTop: 8, color: '#999', fontSize: 12 }}>
                            请在微信小程序搜索“宁盾令牌”扫描二维码进行绑定
                        </div>
                    </div>
                )}
            </Modal>
        );
    }
}

export default VerifyCode;
